

class newMessageController {
    /* @ngInject */
    constructor(MessageOutboundService, ModalFactory, $timeout, $translate, $log, MerchantConfigurationService, FoundationApi, NewTokenService) {

        var mc_this = this;

        this.slider = [{
            img: {
                src: require('../../../img/message_outbound/slider/1.jpg'),
                alt: ''
            }
        },
            {
                img: {
                    src: require('../../../img/message_outbound/slider/2.jpg'),
                    alt: ''
                }
            },
            {
                img: {
                    src: require('../../../img/message_outbound/slider/3.jpg'),
                    alt: ''
                }
            },
            {
                img: {
                    src: require('../../../img/message_outbound/slider/4.jpg'),
                    alt: ''
                }
            }
        ]

        this.step = null;


        this.option_boxes_object = {
            bound_type: ["inbound", "outbound", "welcome"],
            // rich_type: [], // step tolto
            targets: [],
            customization: ['sale', 'gift', 'event'],
            timing: [],
            preview: [],
        };

        this.main_steps = ['bound_type', 'rich_type', 'targets', 'customization', 'timing', 'preview'];
        //this.progessbar_steps = [ 'targets', 'customization', 'timing', 'preview' ];
        this.progessbar_steps = this.main_steps.slice(2, 6);
        this.main_step = 'bound_type';



        this.main_steps_choice = {
            bound_type: null, // in out
            targe_object: {},
            timing: undefined
        };

        this.default_message = {
            welcome: {
                static: "Benvenuto <Nome Cliente> da <Nome Negozio>,",
                editable: ""
            },
            welcome_back: {
                static: "Bentornato <Nome Cliente> da <Nome Negozio>,",
                editable: ""
            }
        }

        this.target_customizations = [{
            slug: 'anagrafica',
            items: [{
                type: 'standard',
                slug: 'sex',
                options: ['male','female', 'all'],
                section: 'all'
            }, {
                type: 'repeat_array',
                slug: 'age',
                options: ['12-17', '18-29', '30-39', '40-49','50+', 'all'],
                section: 'all',
                actual_selection: 'all'
            }]
        },
            {
                slug: 'comportamento',
                items: [{
                    type: 'standard',
                    slug: 'already_buy',
                    options: ['yes', 'no', 'all'],
                    section: 'all',
                }]
            }
        ];

        this.default_selection_age = 'all'
        this.selection_age = 'all'

        this.target_default = {
            anagrafica: {
                sex: "all",
                age: []
            },
            comportamento: {
                already_buy: "all"
            }
        };


        this.main_steps_choice.targe_object = this.target_default;
        // this.main_steps_choice.timing = 'all_day';


        // variabili per il 3° Step: Customization
        this.customization_distance = {
            type: 'standard',
            slug: 'distance',
            options: ['2', '5', '10'],
            section: '2'
        }

        this.main_steps_choice.distance_km = this.customization_distance.section;
        this.customization_template_groups = ['sale', 'gift', 'event'];

        // variabili per il 3° Step: timing

        // this.timing_time_options = ['morning', 'afternoon', 'evening', 'all_day'];

        this.changeRepeatSelec = () => {

        }

        this.addRepeatSelec = (parent, item, selection) => {
            if (selection === 'all') {
                this.main_steps_choice.targe_object[parent][item] = []
            } else {
                this.main_steps_choice.targe_object[parent][item].push(selection)
            }
            this['selection_'+item] = this['default_selection_'+item]
        }



        this.box_selected = (option) => {
            console.log("box_selected", option)
            this.main_steps_choice[this.main_step] = option;
            // if (this.main_step == 'targets') {
            //   // var obj = this.step_object[this.main_steps_choice['bound_type']][this.main_steps_choice['rich_type']][option];
            //   // if (obj)
            //   //   this.main_steps_choice.targe_object = obj;
            //   //this.selection.step_2_customizations = obj;
            //   // this.aggiorna_range();
            //   //this.range_change_event(Math.floor((Math.random() * 100) + 1));
            // }
        };

        this.get_traslations_computed_string = (option, divider) => {
            if (!divider)
                divider = ".";
            var str = "";
            for (var i = 0; i < this.main_steps.length; i++) {
                str = str + this.main_steps[i] + divider;
                if (this.main_steps[i] == this.main_step)
                    break;
                var s = this.main_steps_choice[this.main_steps[i]];
                if (s)
                    str = str + s + divider;
                if (this.main_step == 'welcome' && this.main_steps[i] == 'bound_type') {
                    break;
                }
            }
            if (option)
                str = str + option;
            return str;
        };

        this.can_next = () => {
            return this.main_step != 'welcome' &&
                this.main_step != 'preview' &&
                (this.main_steps_choice[this.main_step] || this.main_step == 'timing') &&
                (this.main_step != 'customization' || this.main_step == 'customization' && this.main_steps_choice['customization'] && this.message.text)
        };

        this.next = () => {
            console.log("next");
            var index = this.main_steps.indexOf(this.main_step);
            if (this.main_step == 'bound_type') {
                if (this.main_steps_choice[this.main_step] == 'welcome') {
                    this.main_step = 'welcome';
                } else {
                    this.main_steps_choice['rich_type'] = 'not_set';
                    this.main_step = 'targets';
                    // this.box_selected('personalizzabile');
                    this.main_steps_choice[this.main_step] = 'personalizzabile';
                    //this.main_steps_choice.targe_object = this.target_default;
                }
            } else {
                index = index + 1;
                this.main_step = this.main_steps[index];
            }
            if (this.main_step == 'timing') {
                if (this.main_steps_choice.bound_type == 'outbound') {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                } else {
                    this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                }
            }
            if (this.main_step == 'targets') {
                // this.click_su_accordion();
                this.get_message_template();
            }
        };

        this.back = () => {
            console.log("back");
            var index = this.main_steps.indexOf(this.main_step);
            this.main_steps_choice[this.main_step] = null;
            if (this.main_step == 'targets' || this.main_steps_choice['bound_type'] == 'welcome') {
                this.main_step = 'bound_type';
            }
            // else if( this.main_step == 'welcome' ) {
            // 	this.main_step = 'rich_type';
            // }
            else {
                this.main_step = this.main_steps[index - 1];
            }

        };




        this.progess_steps = ['typology', 'targets', 'customization', 'timing', 'preview'];



        this.max_sms_length = 160;



        const date = new Date();
        this.date = new Date();
        this.start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        this.end = new Date(date.getFullYear(), date.getMonth() + 1, date.getDate());
        this.daterange_limit = [new Date(date.getFullYear(), date.getMonth(), date.getDate()), new Date(date.getFullYear(), date.getMonth() + 1, date.getDate())];
        this.minDate = new Date();
        this.maxDate = new Date(date.getFullYear(), date.getMonth() + 3, date.getDate());

        this.changeDate = (modelName, newDate) => {
            console.log(modelName + ' has had a date change. New value is ' + newDate.format());
            if (modelName == 'start')
                this.message.promo_period.start_at = newDate;
            else
                this.message.promo_period.end_at = newDate;
            //$scope.callbackState = 'Callback: Fired';
        };
        //this.changeDate('start', this.start);
        //this.changeDate('end', this.end);

        this.my_step_2_filter = (item) => {
            return item.section == 'all' || item.section == this.selection.step_1;
        };
        this.my_step_3_messages_filter = (item) => {
            return item.step_1 == 'all' || item.step_1 == this.selection.step_1;
        };

        this.welcome_messages = {
            //cluster: undefined,
            welcome: $translate.instant('outbound.message.step_12.welcome.message'),
            welcome_back: $translate.instant('outbound.message.step_12.welcome_back.message'),
        };

        this.message = {
            cluster: 0,
            timing: undefined,
            text: undefined,
            promo_period: {
                start_at: this.start,
                end_at: this.end
            }
        };

        this.selection = {
            step_1: undefined,
            step_2: undefined,
            step_2_customizations: undefined,
            step_3: undefined,
            step_3_editing: false,
            step_4_date: undefined,
            step_4_day_period: undefined,
        }

        this.appliedWizardClass = (step) => {
            var str = "bs-wizard-step small-3 grid-content";
            var index_ora = this.main_steps.indexOf(this.main_step);
            var index_step = this.main_steps.indexOf(step);
            if (index_ora == index_step)
                str = str + " active";
            else if (index_ora > index_step)
                str = str + " complete";
            else
                str = str + " disabled";
            return str;
        };


        this.select_step_1_box = (option) => {
            this.selection.step_1 = option;
        };


        this.select_message_box = (option) => {
            this.main_steps_choice['customization'] = option;
            this.selection.step_3_editing = false;

            return;
            this.selection.step_3 = option;
            this.message.text = undefined;

            //FIXME carica altri messaggi
            this.messages = this.messages_object_tmp[option];
        };
        this.step_3_edit_message = (message) => {
            this.selection.step_3_editing = true;
            this.message.text = message.content;
        };


        this.save_welcome_message = () => {
            //$log.debug('Messaggio inviato');
            console.log("1",this.userContext)
            console.log("2",this.default_message)
            MessageOutboundService.updateDefaultMessage(this.userContext, this.default_message).then((response) => {
                //alert("ok");
                this.default_message = response.response;
                FoundationApi.publish('notifications', {
                    color: 'success',
                    title: $translate.instant('common.info'),
                    //content: $translate.instant('common.info'),
                    content: "Il messaggio è stato salvato correttamente", // FIXME translate
                    autoclose: 3000
                });
            }, reason => {
                FoundationApi.publish('notifications', {
                    color: 'alert',
                    title: $translate.instant('common.error'),
                    //content: UiService.parseErrorMessage(data.message),
                    autoclose: 3000
                });
            }).finally(() => {
                $log.debug('prova finally');
            });

        };

        this.already_save_message = false;
        this.save_message = () => {
            if (this.already_save_message == true)
                return;
            //$log.debug('Messaggio inviato');
            var start_time, end_time;
            switch (this.main_steps_choice['timing']) {
                case 'morning':
                    start_time = "08:00:00";
                    end_time = "14:00:00";
                    break;
                case 'afternoon':
                    start_time = "14:00:00";
                    end_time = "18:00:00";
                    break;
                case 'evening':
                    start_time = "18:00:00";
                    end_time = "24:00:00";
                    break;
                case 'all_day':
                    start_time = "08:00:00";
                    end_time = "24:00:00";
                    break;
            }
            var obj = {
                "merchant_id": this.userContext.idWallet,
                "status": "active",
                "bound_type": this.main_steps_choice.bound_type,
                "rich_type": this.main_steps_choice.rich_type,
                //"content_type": this.main_steps_choice.content_type,
                "distance_km": this.main_steps_choice.bound_type === 'inbound' ? this.main_steps_choice.distance_km : null,
                "content_type": this.main_steps_choice.customization,
                "message": this.message.text,
                "target_slug": this.main_steps_choice.targets,
                "target": this.main_steps_choice.targe_object,
                "start_at": this.formatDate(this.start),
                "end_at": this.formatDate(this.end),
                "start_time": start_time,
                "end_time": end_time
            };
            MessageOutboundService.saveCampaign(this.userContext, obj).then((response) => {
                this.default_message = response.response;
                FoundationApi.publish('notifications', {
                    color: 'success',
                    title: $translate.instant('common.info'),
                    //content: $translate.instant('common.info'),
                    content: "Il messaggio è stato salvato correttamente", // FIXME translate
                    autoclose: 3000
                });
            }, reason => {
                FoundationApi.publish('notifications', {
                    color: 'alert',
                    title: $translate.instant('common.error'),
                    //content: UiService.parseErrorMessage(data.message),
                    autoclose: 3000
                });
            }).finally(() => {
                $log.debug('prova finally');
                this.already_save_message = true;
            });
        };

        this.formatDate = (date) => {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        };

        this.change_customization = (customization_slug, customization_item_slug) => {
            this.selection.step_2 = 'personalizzabile';
            // this.aggiorna_range();
        };

        //   this.aggiorna_range_waiting = false;
        //   this.target_percentage = 0.0;
        //   this.aggiorna_range = () => {
        //   	this.aggiorna_range_waiting = true;
        //   	this.range_change_event(Math.floor((Math.random() * 100) + 1));
        //   	var obj = {
        //   		bound_type: this.main_steps_choice.bound_type,
        //   		rich_type: this.main_steps_choice.rich_type,
        //   		target_slug: this.main_steps_choice.targets,
        //   		targets: this.main_steps_choice.targe_object
        //   	};
        //   	MessageOutboundService.getTargetPercentage(this.userContext, obj).then((response) => {
        // 		//$log.debug('prova ok');
        // 		this.target_percentage = response.response.value;
        // 		this.range_change_event( this.target_percentage );
        // 	}).finally(() => {
        // 		$log.debug('prova finally');
        // 		this.aggiorna_range_waiting = false;
        // 	});
        // }


        this.getRangeData = (date_to_t) => {
            var d = new Date(date_to_t);
            return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
        };

        this.range_change_event = (value) => {
            value = this.target_percentage; // da vedere
            var lbl = document.querySelector("#lbl");
            var mask = document.querySelector('#mask');
            var meter_needle = document.querySelector('#meter_needle');
            if (mask == null)
                return;
            var percent = value;
            var meter_value = semi_cf - ((percent * semi_cf) / 100);
            mask.setAttribute('stroke-dasharray', meter_value + ',' + cf);
            meter_needle.style.transform = 'rotate(' + (270 + ((percent * 180) / 100)) + 'deg)';
            lbl.textContent = percent + '%';
        };

        this.get_message_template = () => {

            MessageOutboundService.getTemplateMessages(this.userContext, this.main_steps_choice.bound_type, this.main_steps_choice.rich_type).then((response) => {
                //$log.debug('prova ok');
                //console.log(response);
                this.tempate_messages = response.response;
            }).finally(() => {
                $log.debug('prova finally');
            });


        };









        this.loader = {
            cluster: true,
            sendMessage: false
        };



        this.numUser = undefined;

        let modal = undefined;

        const closeModal = () => {
            modal.deactivate();
            $timeout(modal.destroy, 10);
        };

        const loadMessageConfiguration = () => {
            MerchantConfigurationService.getCheckinConfiguration().then((settings) => {
                this.messageOutboundEnabled = settings.message;
            }, (reason) => {
                $log.error('CheckinSettingsController', 'loadSettings', reason);
            });
        };

        const loadMerchantProfile = () => {
            this.userContext = NewTokenService.getUserContext();
        };


        const init = () => {
            loadMerchantProfile();
            loadMessageConfiguration();

            MessageOutboundService.getDefaultMessage(this.userContext).then((response) => {
                //$log.debug('prova ok');
                //console.log(response);
                this.default_message = response.response;
            }).finally(() => {
                $log.debug('prova finally');
            });

        };

        this.$onInit = init;
    }
}

var semi_cf, cf;

export default newMessageController;


/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/new/new.controller.js
 **/